import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";


const Blog=()=>{

return (<>
  <div className="home">
                <div id="page" className="hfeed page-wrapper">
                    <Header />
                    <div id="site-main" className="site-main">
  <div id="main-content" className="main-content">
    <div id="primary" className="content-area">
      {/* <div id="title" className="page-title">
        <div className="section-container">
          <div className="content-title-heading">
            <h1 className="text-title-heading">Wedding &amp; Bridal</h1>
          </div>
          <div className="breadcrumbs">
            <a href="/products">Home</a>
            <span className="delimiter" />
            Wedding &amp; Bridal
          </div>
        </div>
      </div> */}
      <div id="content" className="site-content" role="main">
        <div className="section-padding">
          <div className="section-container p-l-r">
            <div className="posts-list grid">
              <div className="row">
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/1.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          Bridial Fair Collections 2023
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">July 24, 2023</span>
                        <span className="post-comment">1 Comment</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/2.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          Our Sterling Silver
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">August 16, 2023</span>
                        <span className="post-comment">4 Comments</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/3.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          New Season Modern Gold Earrings
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">October 04, 2023</span>
                        <span className="post-comment">3 Comments</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/4.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          Glossary of Jewellery Terms
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">October 20, 2023</span>
                        <span className="post-comment">1 Comment</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/5.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          Unique First Anniversary Gift Ideas
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">December 11, 2023</span>
                        <span className="post-comment">5 Comments</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/6.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          Hypoallergenic Wedding Bands
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">February 07, 2023</span>
                        <span className="post-comment">2 Comments</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/7.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          Guide to Engagement Ring Styles
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">July 24, 2023</span>
                        <span className="post-comment">3 Comments</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/3.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          Ultimate Guide To Women's Wedding Bands
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">July 24, 2023</span>
                        <span className="post-comment">1 Comment</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/3.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          New Season Modern Gold Earrings
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">October 04, 2023</span>
                        <span className="post-comment">3 Comments</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/4.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          Glossary of Jewellery Terms
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">October 20, 2023</span>
                        <span className="post-comment">1 Comment</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/5.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          Unique First Anniversary Gift Ideas
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">December 11, 2023</span>
                        <span className="post-comment">5 Comments</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                  <div className="post-entry clearfix post-wapper">
                    <div className="post-image">
                      <a href="/blogDetails">
                        <img src="../assets/media/blog/1.jpg" alt="" />
                      </a>
                    </div>
                    <div className="post-content">
                      <div className="post-categories">
                        <a href="#0">Wedding &amp; Bridal</a>
                      </div>
                      <h2 className="post-title">
                        <a href="/blogDetails">
                          Wedding Planning Advice
                        </a>
                      </h2>
                      <div className="post-meta">
                        <span className="post-time">July 24, 2023</span>
                        <span className="post-comment">5 Comments</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <nav className="pagination">
              <ul className="page-numbers">
                <li>
                  <a className="prev page-numbers" href="#">
                    Previous
                  </a>
                </li>
                <li>
                  <span aria-current="page" className="page-numbers current">
                    1
                  </span>
                </li>
                <li>
                  <a className="page-numbers" href="#">
                    2
                  </a>
                </li>
                <li>
                  <a className="page-numbers" href="#">
                    3
                  </a>
                </li>
                <li>
                  <a className="next page-numbers" href="#">
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      {/* #content */}
    </div>
    {/* #primary */}
  </div>
  {/* #main-content */}
</div>
<Footer/>
</div>

</div>

</>)




}

export default Blog;